// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cS5ob","tabsBox":"styles_tabsBox__1ciC-","createButton":"styles_createButton__1vzMQ"};